import React, { useState, useEffect } from "react";
import config from "../data/siteConfig";
import { ScallopDivider } from "./Decor";
import { FiPhone, FiMenu, FiX } from "react-icons/fi";

const links = [
  ["Home", "home"],
  ["Heritage", "about"],
  ["Collections", "collections"],
  ["Gallery", "gallery"],
  ["Showcase", "showcase"],
  ["Our Shop", "ourshop"],
  ["Visit", "visit"],
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // scroll-spy: highlight the nav item for the section in view
  useEffect(() => {
    const ids = links.map((l) => l[1]);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);

  const tel = `tel:${config.contact.phonePrimary.replace(/\s/g, "")}`;

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        solid ? "bg-parchment/95 shadow-soft" : "bg-parchment/80"
      } backdrop-blur border-b border-gold/30`}
    >
      <div className="container-x flex items-center justify-between gap-4 py-2.5">
        <a href="#home" className="flex items-center gap-3">
          <img src={config.brand.logo} alt={config.brand.name} className="h-14 w-auto drop-shadow" />
          <span className="leading-tight">
            <strong className="block font-display text-lg tracking-wide text-coffee-800">
              Shree Abhushan Jewellers
            </strong>
            <small className="block text-[0.66rem] uppercase tracking-[0.28em] text-coffee-500">
               Bhachau, Kutch
            </small>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map(([label, id]) => {
            const on = active === id;
            return (
              <a
                key={id}
                href={`#${id}`}
                className={`group relative font-body text-[0.8rem] font-semibold uppercase tracking-[0.12em] transition-colors ${
                  on ? "text-coffee-900" : "text-coffee-600 hover:text-coffee-900"
                }`}
              >
                {label}
                <span
                  className={`absolute -bottom-1 left-0 h-px bg-gold transition-all duration-300 ${
                    on ? "w-full" : "w-0 group-hover:w-full"
                  }`}
                />
              </a>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <a className="btn btn-gold hidden sm:inline-flex" href={tel}>
            <FiPhone /> Call Now
          </a>
          <button
            className="text-2xl text-coffee-800 lg:hidden"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      <ScallopDivider className="block h-3 w-full" />

      {/* mobile menu */}
      {open && (
        <nav
          className="lg:hidden border-t border-gold/30 bg-parchment px-6 py-4 shadow-soft animate-fade-in"
          onClick={() => setOpen(false)}
        >
          <div className="flex flex-col gap-3">
            {links.map(([label, id]) => (
              <a
                key={id}
                href={`#${id}`}
                className={`font-body uppercase tracking-wider ${
                  active === id ? "text-coffee-900" : "text-coffee-600"
                }`}
              >
                {label}
              </a>
            ))}
            <a className="btn btn-gold mt-2 w-max" href={tel}>
              <FiPhone /> Call Now
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
